module.exports = __webpack_public_path__ + "c2005381069df6f48948f56e1c0ae11e.svg";